<template>
  <Modal name="UPDATE_COUNTRY_MODAL" :title="$t('profile.label.updateLanguage')">
    <template v-slot:body>
      <v-select
        v-model="currentLanguage"
        :label="$t('language.currentLanguage')"
        :loading="isLoading"
        :items="list"
        hide-details="auto"
        class="mb-2"
        outlined
      />
    </template>
  </Modal>
</template>

<script>
import { countriesList } from '../../util/enums'
import { setLanguage } from '../../util/language'
import { updateLanguage } from '@/services/user/userService'

import Modal from '@/components/app/Modal'

export default {
  components: { Modal },

  methods: {
    async updateLanguage(language) {
      this.isLoading = true
      const langObject = this.findLanguageCode(language)

      if (langObject?.code) {
        await updateLanguage({ language: langObject.code })
          .then(() => setLanguage(langObject.language_code))
          .then(() => window.location.reload())
          .catch((error) => console.error(error))
          .finally(() => this.isLoading = false)
      }
    },

    findLanguageCode(value) {
      return countriesList.find((item) => item.language_code === value)
    },
  },

  computed: {
    list() {
      const list = []

      countriesList.map((item) => {
        list.push({
          text: `${item.flag} ${item.country}`,
          value: item.language_code,
        })
      })

      return list
    },

    currentLanguage: {
      get() {
        return localStorage.getItem('user_language') ?? 'pt-BR'
      },
      set(value) {
        this.updateLanguage(value)
      }
    }
  },

  data() {
    return {
      countriesList,
      isLoading: false,
    }
  }
}
</script>
